export const apiUrl = process.env.WEB_API_URL
